type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

/**
 * Eighth-note glyph — small, simple, single-note shape. Used as the prefix
 * icon on YouTube Shorts' sound-attribution row and reusable by future
 * overlays that paint a music/sound row (TikTok, Reels). Filled rather than
 * stroked so the note head reads cleanly at small sizes.
 *
 * Distinct from the existing `MusicIcon` (a larger two-note beamed pair used
 * in `SongCollection` / `AudioLibrary`) — that one is heavier and stroked,
 * intended for the sidepanel's music-picker UI.
 */
const MusicNoteIcon = (props: Props) => {
  const {
    width = '12',
    height = '12',
    viewBox = '0 0 12 12',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      {/* Stem rising from the note head, with a small flag at the top. */}
      <path
        d="M5 9 V 1.5 L 10 0.5 V 7"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Note head — filled ellipse. */}
      <ellipse cx="3.4" cy="9" rx="1.9" ry="1.4" fill={fillColor} />
      {/* Stem-end head. */}
      <ellipse cx="8.4" cy="7" rx="1.9" ry="1.4" fill={fillColor} />
    </svg>
  );
};

export default MusicNoteIcon;
